import { api } from './client'

export function fetchSkippedPriorityIds(weekStart: string): Promise<string[]> {
  return api.get(`/api/time-logs/skipped?weekStart=${weekStart}`)
}

export function skipPriorityWeek(priorityId: string, weekStart: string): Promise<void> {
  return api.post('/api/time-logs/skip', { priorityId, weekStart })
}

export function unskipPriorityWeek(priorityId: string, weekStart: string): Promise<void> {
  return api.post('/api/time-logs/unskip', { priorityId, weekStart })
}
